import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import { ManageSeparationsButton } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Components';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { TestProcedure } from '../../types';

// Button to bring up Manage Separations dialogs adjusted to the BS EN requirements
let BsEnManageSeparationsButton: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const isAnnexA = useSelector(
    pipe(createWorksheetSelector!('data.Preparation.Method', false), (m) => m === TestProcedure.AnnexA)
  );

  return (
    <>
      <ManageSeparationsButton
        maxSeparations={2}
        defaultSieveSizes={isAnnexA ? ['16_0', '6_3'] : ['20_0', '6_3']}
        notEditableSeparations={isAnnexA ? ['16_0'] : []}
      />
    </>
  );
};

BsEnManageSeparationsButton = withInjectedProps(BsEnManageSeparationsButton);
export { BsEnManageSeparationsButton };
